export default "__VITE_ASSET__BfdX9CgC__"